import { createApp } from "vue";
import { createPinia } from "pinia";
import ElementPlus from "element-plus";
import App from "@/App.vue";
import router from "./router/index";
import VueGtag from "vue-gtag";

import TitleUnderline from "./components/base/TitleUnderline.vue";

/* import the fontawesome core */
import { library } from "@fortawesome/fontawesome-svg-core";
/* import font awesome icon component */
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

import { faCaretRight as fasCaretRight } from "@fortawesome/free-solid-svg-icons";
import { faArrowDown as fasArrowDown } from "@fortawesome/free-solid-svg-icons";
import { faChevronDown as fasChevronDown } from "@fortawesome/free-solid-svg-icons";
import { faChevronUp as fasChevronUp } from "@fortawesome/free-solid-svg-icons";
import { faChevronLeft as fasChevronLeft } from "@fortawesome/free-solid-svg-icons";
import { faChevronRight as fasChevronRight } from "@fortawesome/free-solid-svg-icons";
import { faPlay as fasPlay } from "@fortawesome/free-solid-svg-icons";
import { faPodcast as fasPodcast } from "@fortawesome/free-solid-svg-icons";
library.add(fasCaretRight, fasArrowDown, fasChevronUp, fasChevronDown, fasChevronLeft, fasChevronRight, fasPlay, fasPodcast);

import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap";
import "element-plus/dist/index.css";

import "@/assets/all.scss";

import "bootstrap-icons/font/bootstrap-icons.css";

const app = createApp(App);
app.component("TitleUnderline", TitleUnderline);
app
  .use(createPinia())
  .component("font-awesome-icon", FontAwesomeIcon)
  .use(ElementPlus)
  .use(router)
  .use(VueGtag, {
    config: { id: "GTM-PMGM6QD" },
  })
  .mount("#app");
